export class CreateProfileModel {
  public descricao: string = ''
}

export class ProfileModel {
  public id?: number
  public descricao?: string
}

export class EditProfileModel {
  public id: number = 0
  public descricao: string = ''
}

export class DeleteProfileModel {
  public id: number = 0
  public descricao: string = ''
}

export class SearchProfileModel {
  public descricao: string = ''
}

export class CreateProfileResponse {
  public response: any
}
export class EditProfileResponse {
  public response: any
}
export class DeleteProfileResponse {
  public response: any
}
export class PagedProfileResponse {
  public response: any
}
